module.exports = __webpack_public_path__ + "static/media/privacy-footer.7d5087cf.svg";